import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { source } from 'react-aim';
import { Popup, } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';

const style = {
  borderRadius: 0,
  opacity: 0.8,
  padding: '6px'
}

@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext(props.name);
  }
})


export default class extends Component {
  async handelMenuIcon() {
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    if (this.props.resourcePaneFunction) {
      this.props.resourcePaneFunction(null);
    }
    dispatch.lifeCycle.setArrangementPaneFlag(false);
    await dispatch.initiatives.initiativeAggangementPane(null);
    await dispatch.lifeCycle.disableLinking();
    await dispatch.app.showTeamListView(true);
    dispatch.createPack.setSelectedActivityData({});
    dispatch.lifeCycle.setSelectedPracticeLibraryData({});
    dispatch.initiatives.setSelectedActivityData({});
    dispatch.initiatives.setSelectedDataById({})

  }


  render() {
    return (
      <li>
        <Popup trigger={
          <NavLink
            to={this.props.to}
            className={this.props.className}
            onClick={() => this.handelMenuIcon()}
            disabled>
            {this.props.name}

          </NavLink>
        }
          content={this.props.name}
          position='right center'
          style={style}
          inverted
        />

      </li>
    );
  }
}